import { config } from "../../config"
import { sha256 } from "../../helpers/jwt"

const token = {
  newToken: async ({ username, rawPassword }) => {
    const hashedPassword = sha256(rawPassword)

    const url = config.apiUrl + "/token",
      opt = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, hashedPassword }),
      }

    return { url, opt }
  },
}

export { token }
